




















import { defineComponent } from "@vue/composition-api";
import contenedorCargadorVue from "./contenidos/contenedorCargador.vue";

export default defineComponent({
  components: {
    Contenedor: contenedorCargadorVue,
  },
  setup() {
    return {
      drawer: null,
      titulo: process.env.VUE_APP_TITULO_NAVEGACION || 'Inicio' 
    };
  },
});
